import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = () =>
  ({
    authGrid: {
      flex: "1",
      display: "grid",
      gridTemplateColumns: "repeat(12, 1fr) 24px",

      "@media (max-width:1439px)": {
        gridTemplateColumns: "24px repeat(12, 1fr)"
      },

      "@media (max-width:839px)": {
        gridTemplateColumns: "1fr"
      }
    },
    itemGrid: {
      display: "flex",
      flexDirection: "column",
      gridColumn: "1 / span 5",

      "@media (max-width:1439px)": {
        gridColumn: "1 / span 6"
      }
    },

    logo: {
      display: "flex",
      padding: "16px 24px",

      "@media (max-width:599px)": {
        padding: "16px"
      }
    },
    loginContentContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: "1",
      padding: "0 112px",

      "@media (max-width:1439px)": {
        padding: "0 24px"
      },

      "@media (max-width:599px)": {
        padding: "0 16px"
      }
    },
    innerLoginContentContainer: {
      maxWidth: "500px"
    },
    loginContentHeaders: {
      marginBottom: "32px",
      color: colors.textDark
    },
    togglePasswordVisibilitySpan: {
      display: "flex",
      cursor: "pointer",
      color: colors.gray500,
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

      "&:hover": {
        color: colors.gray600
      }
    },
    contactsOuterDiv: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      columnGap: "16px",
      marginTop: "16px"
    },
    privacyPolicyDiv: {
      color: colors.textDark,
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "12px",
      letterSpacing: "0.4px",
      maxWidth: "208px",

      "& > a": {
        display: "inline"
      }
    },
    contactIconsDiv: {
      display: "flex",
      alignItems: "center",

      "& > a + a": {
        marginLeft: "16px"
      }
    },
    blockWithBottomSpacing: {
      marginBottom: "16px"
    },
    passwordValidationBlock: {
      "& > div": {
        display: "flex",
        alignItems: "center"
      },

      "& > div + div": {
        marginTop: "4px"
      }
    },
    termsOfServiceCSS: {
      paddingBottom: "16px",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "0.1px"
    }
  }) as CSSObject;
